export default function MarketingData() {
    return [
        {
            text: [
                {
                    title: "The Gift of Insurability",
                    paragraphs: ["With children's whole life insurance, parents and grandparents can give their children the gift of insurability. Obtaining coverage today is fast and simple with no medical exam, and the coverage doubles upon the child’s 18th birthday. The policy also provides opportunities to increase up to 10 times the original amount with no additional underwriting.",
                        "This gift that will keep on giving can also serve as an alternative savings account as the policy builds cash value over time, and offers a guaranteed 4 percent interest rate."],
                }
            ]
            ,
            image: "/product-landing/chil/circle2.png"
        },
        {
            text: [
                {
                    title: "What is Life Insurance?",
                    paragraphs: ["Life insurance is a financial planning tool that pays a specified, tax-free amount of money to family, friends or other beneficiaries in the event of death. Coverage is available is many variations that can be customized to fit your needs."],
                }
            ]
            ,
            image: "/product-landing/chil/circle3.png"
        },
        {
            text: [
                {
                    title: "Types of Life Insurance",
                    paragraphs: ["Broad categories of life insurance include permanent and term coverage. Term insurance is an excellent option for low budget temporary coverage. Because of its temporary nature, it isn’t as valuable or flexible as permanent coverage.",
                        "Permanent life insurance can provide benefits in many ways, including coverage that remains in force for one’s whole life. It can also be used for long-term savings, supplemental retirement, and offers various tax advantages."],
                }
            ]
            ,
            image: "/product-landing/chil/circle4.png"
        }
    ];
}
